import React from 'react'
import { Form } from 'react-redux-form/immutable'
import Panel from 'react-bootstrap/lib/Panel'

import FormHeader from './form-header'
import ListSubjects from './list-subjects'

const Wrapper = ({ data }) => (
  <Panel header="Report of Grades">
    <Form model="gradeState" className="grid-form">
      <FormHeader data={data.get('header')} />
      <ListSubjects data={data} />
    </Form>
    <small className="text-muted"><em>*** You may request a printed copy of this Report of Grades at the Registrar's Office.</em></small>
  </Panel>
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/containers/Grades/wrapper.js